import { ActionKeys } from '@/configs/router/actions';
import type { Auth } from '@/scripts/router/auth';
import { useAccess } from '@/scripts/router/auth';

export interface AccessPageProps {
  authKey: Auth['key'];
  children: ReactNode;
}

export default function AccessPage({ authKey, children }: AccessPageProps) {
  const hasAccess = useAccess()(authKey)(ActionKeys.VIEW);

  if (!hasAccess) {
    return <div>403</div>;
  }

  return children;
}
